<div class="flex flex--row stepper">
  <div
    role="tablist"
    *ngFor="let step of steps; let last = last; let index = index"
    [class.ms-xxsmall-r]="!last"
    [ngClass]="{
      'align-center center flex-1 flex--basis0': showLabels
    }"
  >
    <button
      role="tab"
      (click)="clicked.emit(steps[index])"
      [attr.aria-label]="step.ariaLabel | finLocalization"
      [class.inverted]="darkMode"
      [disabled]="index > activeStep"
    >
      <span
        *ngIf="showLabels"
        [ngClass]="{
          'nordic-blue-100-text regular-type': index > activeStep && !darkMode,
          'nordic-blue-300-text': index > activeStep && darkMode
        }"
        [class.white-text]="darkMode"
        [class.medium-type]="index <= activeStep"
        class="block ps-small-b font-body-2"
        >{{ step.title | finLocalization }}</span
      >
      <div class="atom inline-block rounded-large ps-xxsmall-y ps-xxlarge-l center"></div>
    </button>
  </div>
</div>
